import { CourierProps } from '../types/default'
import { OrderProps, OrderBySellerProps } from '../types/tracking'
import DEFAULT from '../config/default'
import { redirectGuide } from './interrapidisimo'

const countryCode: string | undefined = DEFAULT.api.countryCode

const resource = (value: string) => {
    return `${ DEFAULT.project.baseHref }/resources/${ value }`
}

const orderNumber = (order: OrderProps | OrderBySellerProps): number => {
    // if (countryCode) {
    //     if (['AR', 'EC'].includes(countryCode)) {
    //         return order.atg ?? order.id
    //     }
    // }
    // return order.id
    return order.atg ?? order.id
}

const findCourier = (order: OrderProps, isParent: boolean = true): CourierProps | undefined => {

    const courier = (DEFAULT.project.couriers || []).find((c) => c.id === order.idTransportista)
    
    if (courier) {
        if (countryCode) {
            if (countryCode === 'AR') {
                if (
                    ['URBANO', 'PAUL GABRIEL', 'CARO', 'RAICES'].includes(courier.name)
                ) {
                    return { ...courier, urlToTracking: `${ courier.url }${order.id}`}
                } else if (['PICKIT'].includes(courier.name)) {
                    return { ...courier, urlToTracking: `${ courier.url }${order.id}?token=X8WQXRMQY3`}
                } else if (['OCA'].includes(courier.name) && order.numeroGuia) {
                    return { ...courier, urlToTracking: `${ courier.url }${order.numeroGuia}`}
                } else if (['ANDREANI'].includes(courier.name)) {
                    if (order.tieneHijos) {
                        return { ...courier, isMultibulto: true }
                    } else {
                        return { ...courier, urlToTracking: `${ courier.url }${order.numeroGuia}` }
                    }
                } else if (['DPD'].includes(courier.name)) {
                    if (order.tieneHijos) {
                        return { ...courier, isMultibulto: true }
                    } else {
                        return { ...courier, urlToTracking: `${ courier.url }${order.numeroGuia}` }
                    }
                } else if (['30DENOVIEMBRE'].includes(courier.name)) {
                    if (order.tieneHijos) {
                        return { ...courier, isMultibulto: true }
                    } else {
                        if (!order.numeroGuia) {
                            return courier
                        }
                        return { ...courier, urlToTracking: `${ courier.url }/${order.numeroGuia}` }
                    }
                } else if (courier.name.startsWith("FLEET")) {
                    if (order.tieneHijos) {
                        return { ...courier, isMultibulto: true }
                    } else {
                        return { ...courier, urlToTracking: `${ courier.url }${isParent ? order.id : order.idPadre}` }
                    }
                } else if (courier.name.startsWith("IFLOW")) {
                    if (order.tieneHijos) {
                        return { ...courier, isMultibulto: true }
                    } else {
                        return { ...courier, urlToTracking: `${ courier.url }${isParent ? order.id : order.idPadre}` }
                    }
                }
            } else if (countryCode === 'CH') {
                if (courier.name === 'blueexpress') {
                    return { ...courier, urlToTracking: `${ courier.url }?n_seguimiento=${order.numeroGuia}` }
                } else if (courier.name === '99minutos') {
                    return { ...courier, urlToTracking: `${ courier.url }${order.numeroGuia}` }
                } else if (courier.name === 'starken') {
                    return { ...courier, urlToTracking: `${ courier.url }?codigo=${order.numeroGuia}` }
                } else if (courier.name === 'loginsa') {
                    return { ...courier, urlToTracking: `${ courier.url }?codigo=NATURA&orden=${order.id}` }
                } else {
                    return { ...courier, urlToTracking: courier.url }
                }
            } else if (countryCode === 'PE') {
                if (courier.name === 'aqpmail') {
                    return { ...courier, urlToTracking: `${ courier.url }?tipo=PEDIDO&dato=${order.id}` }
                } else if (courier.name === 'andesexpress') {
                    return { ...courier, urlToTracking: `${ courier.url }?Nguia=${order.id}` }
                } else if (courier.name === 'unionstar') {
                    return { ...courier, urlToTracking: `${ courier.url }${order.id}` }
                } else if (courier.name === 'transolyfer') {
                    return { ...courier, urlToTracking: `${ courier.url }${order.id}` }
                } else if (courier.name === 'sharf') {
                    return { ...courier, urlToTracking: `${ courier.url }${order.id}` }
                } else if (courier.name === 'yobel') {
                    return { ...courier, urlToTracking: `${ courier.url }${order.id}` }
                }  else {
                    return { ...courier, urlToTracking: courier.url }
                }
            } else if (countryCode === 'CO') {
                if (courier.name === 'servientrega') {
                    if (order.numeroGuia) {
                        return { ...courier, urlToTracking: `#/tracking/servientrega/${order.numeroGuia}` }
                    }
                    return courier
                } else if (courier.name === 'interrapidisimo') {
                    if (order.numeroGuia) {
                        return { ...courier, urlToTracking: redirectGuide(order.numeroGuia) }
                    }
                } else if (courier.name === 'envia') {
                    return { ...courier, urlToTracking: `${ courier.url }?Guia=${order.numeroGuia}#modal_rastrea` }
                } else if (courier.name === 'remesas') {
                    return { ...courier, urlToTracking: `${ courier.url }?guia=${order.numeroGuia}` }
                } else if (courier.name === 'logisticajb') {
                    return { ...courier, urlToTracking: `${ courier.url }?codigo=${order.id}` }
                }  else if (courier.name === 'carryt') {
                    return { ...courier, urlToTracking: `${ courier.url }${order.id}` }
                }  else if (courier.name === 'tms_karrera') {
                    return { ...courier, urlToTracking: `${ courier.url }?orden=${order.id}` }
                }  else if (courier.name === 'tvg_cargo') {
                    return { ...courier, urlToTracking: `${ courier.url }?codigo=${order.id}` }
                }  else if (courier.name === 'runbox') {
                    return { ...courier, urlToTracking: `${ courier.url }?ped=${order.numeroGuia}` }
                }  else if (courier.name === 'movo') {
                    return { ...courier, urlToTracking: `${ courier.url }?guia=${order.numeroGuia}` }
                }  else if (courier.name === 'proships') {
                    return { ...courier, urlToTracking: `${ courier.url }?tracking=${order.numeroGuia}` }
                }  else {
                    return { ...courier, urlToTracking: courier.url }
                }
            } else if (countryCode === 'MX') {                
                if (courier.name === 'dhl') {
                    const urlToTracking = `${ courier.url }?submit=1&tracking-id=${order.numeroGuia}`
                    if (order.tieneHijos) {
                        return { ...courier, isMultibulto: true, urlToTracking }
                    } else {
                        return { ...courier, urlToTracking }
                    }
                } else if (courier.name === 'bigsmart') {
                    const urlToTracking = `${ courier.url }?trackingNumber=${order.numeroGuia}`
                    if (order.tieneHijos) {
                        return { ...courier, isMultibulto: true, urlToTracking }
                    } else {
                        return { ...courier, urlToTracking }
                    }
                } else if (courier.name === 'estafeta') {
                    if (order.tieneHijos) {
                        return { 
                            ...courier,
                            isMultibulto: true,
                            urlToTracking: `${ courier.url }/searchByGet?wayBill=${order.numeroGuia}&wayBillType=0&isShipmentDetail=False#modal_rastrea`
                        }
                    } else {
                        if (order.id !== order.idPadre) { // im doing this to check that is actually a child order
                            return {
                                ...courier,
                                urlToTracking: `${ courier.url }/searchByGet?wayBill=${order.numeroGuia}&wayBillType=0&isShipmentDetail=False#modal_rastrea`
                            }
                        } else {
                            return {
                                ...courier,
                                urlToTracking: `${ courier.url }/searchByReference?wayBillType=4&client=5455076&reference=${order.id}`
                            }
                        }
                    }
                } else if (courier.name === 'ampm') {
                    const urlToTracking = `${ courier.url }?Guia=${order.numeroGuia}`
                    if (order.tieneHijos) {
                        return { ...courier, isMultibulto: true, urlToTracking }
                    } else {
                        return { ...courier, urlToTracking }
                    }
                } else if (courier.name === 'distribuidora-ldc') {
                    return { ...courier, urlToTracking: `${ courier.url }?filter_key=guide_number&filter_value=${order.numeroGuia}` }
                } else if (courier.name === 'carryt') {
                    return { ...courier, urlToTracking: `${ courier.url }${order.numeroGuia}` }
                } else if (courier.name === 'movicarga') {
                    return { ...courier, urlToTracking: `${ courier.url }?encodedString=kyPd3DxzWOLuBmsT2unwGrN0GE2EX1gHltF6ATHwGaqxK0GP1g===&param1=${order.numeroGuia}` }
                } else {
                    return { ...courier, urlToTracking: courier.url }
                }
            }
        }

    }

    return undefined

}

export { resource, findCourier, orderNumber }
